import { USER_PROFILE_CONSTANT } from 'model/constants/actionConstants';

const initState = {
	loading: false,
	data: null,
};

export default (state = initState, action) => {
	switch (action.type) {
		case USER_PROFILE_CONSTANT.SET_STATE:
			return { ...state, ...action.payload };
		case USER_PROFILE_CONSTANT.START_FETCHING:
			return { ...state, loading: true };
		case USER_PROFILE_CONSTANT.STOP_FETCHING:
			return { ...state, loading: false };
		case USER_PROFILE_CONSTANT.SET_USER_PROFILE:
			return { ...state, data: action.payload };
		case USER_PROFILE_CONSTANT.RESET:
			return initState;
		default:
			return state;
	}
};
